import { useEffect } from "react";

/** Freeze page scroll while a full-screen ceremony (pack open, raffle draw) is up. */
export function useBodyLock(active: boolean) {
  useEffect(() => {
    if (!active) return;
    document.body.classList.add("ceremony-open");
    return () => document.body.classList.remove("ceremony-open");
  }, [active]);
}
